import React from 'react';

interface PageContextInterface {
  name: string;
  category?: string;
}

const PageContext = React.createContext<PageContextInterface>({
  name: '',
  category: '',
});

interface ProviderProps {
  name: string;
  category?: string;
}

const PageProvider: React.FC<ProviderProps> = ({
  name,
  category,
  children,
}) => {
  const value = React.useMemo(() => ({ name, category }), [category, name]);

  return <PageContext.Provider value={value}>{children}</PageContext.Provider>;
};

export const usePage = () => React.useContext(PageContext);

const PageConsumer = PageContext.Consumer;

export { PageProvider };
export { PageConsumer };
export default PageContext;
